import { LandingNav } from '../components/landing-nav';
import { LandingHero } from '../components/landing-hero';
import { LandingFeatures } from '../components/landing-features';
import { LandingHowItWorks } from '../components/landing-how-it-works';
import { LandingPersonas } from '../components/landing-personas';
import { LandingFaq } from '../components/landing-faq';
import { LandingCta } from '../components/landing-cta';
import { LandingFooter } from '../components/landing-footer';

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <LandingNav />
      <main>
        <LandingHero />
        <LandingFeatures />
        <LandingHowItWorks />
        <LandingPersonas />
        <LandingFaq />
        <LandingCta />
      </main>
      <LandingFooter />
    </div>
  );
}
